<template>
  <div class="footer">
    <!-- <router-link class="link" to="/detail/about">Privacy policy</router-link> -->
    <a class="link" href="/contract/policy.html" rel="external nofollow"  target="_blank">Privacy policy</a>
    <strong></strong>
    <a class="link" href="/contract/terms.html" rel="external nofollow"  target="_blank">Terms of service</a>
    <!-- <router-link class="link" to="/detail/contact">Terms of service</router-link> -->
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: .8rem;
  padding: 0 .4rem;
  .link{
    // text-align: center;
    line-height: .8rem;
    font-size: .16rem;
    // text-transform: uppercase;
    // flex: 1;
    // max-width: 2rem;
    // cursor: pointer;
    text-decoration: none;
    color: #FFFFFF66;
  }
  strong{
    width: .04rem;
    height: .04rem;
    border-radius: .04rem;
    background-color: #FFFFFF66;
    margin: 0 .08rem;
  }
}
</style>
